import {InterchangeableComponentGroup_Create} from "./interchangeable-component-group-create";
import {CompositionComponentLinkerDto} from "../../../_models/_inventory/composition-component-linker-dto";
import {InterchangeableComponentDto} from "./interchangeable-component-dto";
import {ItemDto} from "../../../models/item-dto";

export class Component_Create {
  unit: boolean = false;
  value: number = 0;
  item: string | undefined;
  price: number | undefined = undefined;
  filter: boolean = false;
  interchangeableGroup: InterchangeableComponentGroup_Create | undefined = undefined;

  static from(obj: CompositionComponentLinkerDto | InterchangeableComponentDto): Component_Create {
    let model = new Component_Create();

    if (obj instanceof CompositionComponentLinkerDto) {
      model.unit = obj.component?.unit ?? false;
      model.value = obj.component?.value ?? 0;
      model.item = obj.component?.item;

      // create interchangeable group if there are alternatives
      model.interchangeableGroup = InterchangeableComponentGroup_Create.from(obj.interchangeableComponentGroup);
    } else {
      model.unit = obj.component.unit;
      model.value = obj.component.value;
      model.item = obj.component.item;
      model.price = obj.priceChange;
    }

    return model;
  }

  static create(item: ItemDto, filter: boolean) {
    let component = new Component_Create();

    component.item = item.id;
    component.filter = filter;

    return component;
  }

  SetOptional(isOptional: boolean, defaultItem: ItemDto) {
    if (isOptional) {
      this.item = undefined;
    } else {
      this.item = defaultItem.id;
    }
  }

  isOptional(): boolean {
    return this.item == undefined;
  }
}
